import dynamic from 'next/dynamic';
import { createContext, useContext, useState, useMemo, JSX } from 'react';

const Unauthorized = dynamic(() => import('../components/Auth/Unauthorized'));

type AuthGuardProps = {
  children: JSX.Element;
  isUnauthorized: boolean;
};

type AuthProviderProps = {
  children: JSX.Element;
};

export type AuthContextType = {
  isUnauthorized: boolean;
  setUnauthorized: (value: boolean) => void;
};

export const AuthContext = createContext<AuthContextType | null>(null);
export const useAuth = () => useContext(AuthContext);

const AuthGuard = ({ children, isUnauthorized = false }: AuthGuardProps) => {
  if (isUnauthorized) {
    return <Unauthorized />;
  }

  return children;
};

const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isUnauthorized, setIsUnauthorized] = useState(false);

  const setUnauthorized = (value: boolean) => setIsUnauthorized(value);
  const value = useMemo(() => ({ isUnauthorized, setUnauthorized }), []);

  return (
    <AuthContext.Provider value={value}>
      <AuthGuard isUnauthorized={isUnauthorized}>{children}</AuthGuard>
    </AuthContext.Provider>
  );
};

export default AuthProvider;
